import Node from './node.vue'

export default Node



// WEBPACK FOOTER //
// ./src/lib/components/node/index.js